var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkIconFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5087 4.16836e-09H2.45608C1.79691 0.00983564 1.16829 0.296192 0.707954 0.796331C0.247614 1.29647 -0.0069109 1.96961 0.000142794 2.66827V17.9129C-0.00162551 18.2173 0.0808031 18.5156 0.237244 18.771C0.393685 19.0263 0.617282 19.2275 0.880408 19.3496C1.13022 19.4747 1.40967 19.5176 1.68269 19.4727C1.95572 19.4278 2.20977 19.2972 2.41207 19.0977L7.12149 14.6755C7.22904 14.5847 7.36248 14.5352 7.5 14.5352C7.63752 14.5352 7.77097 14.5847 7.87852 14.6755L12.5879 19.0977C12.7914 19.295 13.0454 19.4241 13.3179 19.4689C13.5904 19.5137 13.8693 19.4722 14.1196 19.3496C14.3827 19.2275 14.6063 19.0263 14.7628 18.771C14.9192 18.5156 15.0016 18.2173 14.9999 17.9129V2.66827C15.0034 2.3192 14.9415 1.97285 14.8179 1.64928C14.6942 1.32571 14.5113 1.03133 14.2796 0.78319C14.0479 0.535045 13.7721 0.338056 13.4682 0.203623C13.1642 0.0691896 12.8381 -1.96111e-05 12.5087 4.16836e-09Z",
    fill: "url(#paint0_linear_10037_2327)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10037_2327",
    x1: 7.5,
    y1: 0,
    x2: 7.5,
    y2: 19.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIconFilled);
export default __webpack_public_path__ + "static/media/bookmarkIconFilled.0a8c5ab582373cdf4dee2ffd00dc51e0.svg";
export { ForwardRef as ReactComponent };